import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    Alert,
    CircularProgress
} from "@mui/material";
import Iconify from "../iconify";

const MasterPasswordDialog = ({
    open,
    onConfirm,
    onClose,
    title = "Master Password Required",
    message = "Please enter the master password to proceed with elevated privileges:",
    loading = false,
    elevatedText = ""
}) => {
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(false);

    const handleConfirm = () => {
        if (!password.trim()) {
            setError(true);
            return;
        }
        onConfirm(password);
        setPassword("");
    };

    const handleClose = () => {
        setPassword("");
        setShowPassword(false);
        setError(false);
        onClose();
    };

    const handleKeyUp = (event) => {
        if (event.key === "Enter") {
            handleConfirm();
        }
    };

    return (
        <Dialog open={open} onClose={loading ? undefined : handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    {message}
                </DialogContentText>
                {elevatedText && (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        Reason: {elevatedText}
                    </Alert>
                )}
                <TextField
                    autoFocus
                    margin="dense"
                    label="Master Password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    variant="outlined"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setError(false);
                    }}
                    onKeyUp={handleKeyUp}
                    error={error}
                    helperText={error ? "Master password is required" : ""}
                    disabled={loading}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                    disabled={loading}
                                >
                                    <Iconify
                                        icon={
                                            showPassword
                                                ? "eva:eye-fill"
                                                : "eva:eye-off-fill"
                                        }
                                    />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button 
                    onClick={handleClose} 
                    variant="outlined"
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleConfirm} 
                    variant="contained"
                    color="primary"
                    disabled={loading || !password.trim()}
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    {loading ? "Confirming..." : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MasterPasswordDialog; 